import { RootState } from '../rootReducer'

export const selectDynamEnum = (state: RootState) => state.dynamEum.enums

